import styled from "styled-components";

export const LaneContainer = styled.div`
  height: ${({ tightLayout, theme }) =>
    tightLayout ? theme.editor.tightLaneHeight : theme.editor.laneHeight};
  position: relative;
`;
